export const translations = {
  en: {
    // Hero
    heroTitle: "Bringing your app idea to life!",
    
    // Navigation
    navAbout: "About",
    navHire: "Hire",
    navReferences: "References",
    navCode: "Code",
    navBlog: "Blog",
    navApps: "Apps",
    navPrivacy: "Privacy Policy",
    
    // About Section
    aboutTitle: "About Me",
    aboutJobTitle: "Freelance App Developer",
    aboutFreelanceTitle: "Freelance",
    aboutFreelanceText: "I am a freelance software engineer with over {years} years of professional experience. Using technologies like C# and .NET MAUI (previously Xamarin.Forms), I will develop your high-quality, cross-platform application. From idea to launch, I will bring your app to life in no-time.",
    aboutCrossPlatformTitle: "Cross-platform",
    aboutCrossPlatformText: "Why cross-platform development? Using a single codebase for multiple platforms, it reduces costs and speeds up the delivery of applications to customers on different platforms, such as Android, iOS, macOS and Windows.",
    aboutModernTitle: "Modern practices",
    aboutModernText: "As an advocate of modern software development principles and practices such as Clean Code, Test-Driven Development and SOLID, I always strive to deliver maintainable and extensible code. In C# .NET based projects, I apply the Model-View-ViewModel (MVVM) pattern to separate the business logic from the UI and deliver testable code.",
    aboutExperienceTitle: "Wealth of experience",
    aboutExperienceText: "As an experienced developer, open source contributor, active member of the Stack Overflow community and developer of several open source components for Xamarin.Forms and .NET MAUI, I bring a wealth of knowledge and expertise to every project.",
    aboutYearsExperience: "years experience",
    
    // References Section
    referencesTitle: "References",
    referencesIntro: "Why don't you join my trusted partners and let me develop your next-gen cross-platform application?",
    
    // Hire Section
    hireTitle: "Hire Me",
    hireIntro: "Let's build something amazing and deliver value to your customers together.",
    hireProjectsTitle: "Projects",
    hireProjectsText: "You can hire me for your .NET based application and software development projects, I offer both mobile and desktop application development. Whether it's a small, medium or large project, working in a team or alone, I will help you with app architecture, development practices, stability, automated tests, refactoring, coaching and more.",
    hireIndustryTitle: "Industry knowledge",
    hireIndustryText: "With my professional experience as a software engineer in the Additive Manufacturing (3D Printing), Medical Software and Personal Training industries, I can quickly adapt to industry needs and help you and your team to hit the target.",
    hireAvailabilityTitle: "Availability",
    hireAvailabilityText: "Based in Germany, I am available for contracts throughout the European Union. With fluency in both English and German, and basic knowledge in Spanish and Portuguese, I am a flexible and versatile developer for international collaboration. Availability and hourly rate on request.",
    hireTouchTitle: "Get in touch",
    hireTouchText: "You are interested in a working with me? Great, just hit me up on LinkedIn or drop me an E-Mail and let's discuss your project.",
    
    // Code Section
    codeTitle: "Code",
    codeIntro: "Explore some of my Open Source repositories on GitHub",
    linksOpenExternally: "(links open externally)",
    
    // Blog Section
    blogTitle: "Blog",
    blogIntro: "I write about software development, .NET MAUI, Xamarin.Forms and other topics related to mobile and cross-platform development.",
    blogReadMore: "Read more on my blog",
    
    // Apps Section
    appsTitle: "epj apps",
    appsIntro: "Here you can find some of my privately developed apps that are currently available in the different stores.",
    relistTitle: "Re:List - Free Simple Modern List Manager",
    relistTagline: "Save time and gain control over your important checklists!",
    relistDescription1: "Re:List allows you to quickly create, reuse, reset and copy lists as well as efficiently organize your list items. Whether it's your frequently used shopping list or a packing list for your annual vacation, Re:List is here to help you to stay organized. With Re:List, you'll never forgot to pack your sunblock or winter hat anymore!",
    relistDescription2: "You can copy single items and entire lists, you can check, reset and delete items, sort by priority, name, date - you have the power over your lists. Your lists are always with you, even when you switch devices (this is optional and requires sign-in using your Google or Apple account to work). Re:List is free to use and completely ad-free.",
    appsPrivacyPolicy: "Privacy Policy",
    
    // Footer
    footerPrivacy: "Privacy Policy",
    footerImprint: "Impressum",
    
    // Impressum Section
    imprintTitle: "Site Notice",
    imprintName: "Julian Ewers-Peters",
    imprintCompany: "IT-Consulting Julian Ewers-Peters",
    imprintStreet: "Brunnenstraße 4",
    imprintCity: "49214 Bad Rothenfelde",
    imprintContactTitle: "Contact",
    imprintPhone: "Phone: +495424218872",
    imprintEmail: "E-mail: julian@ewers-peters.de",
    imprintVatTitle: "VAT ID",
    imprintVatText: "Sales tax identification number according to Sect. 27 a of the Sales Tax Law:",
    imprintVatId: "DE320743648",
    imprintLiabilityTitle: "Information regarding professional liability insurance",
    imprintLiabilityInsurer: "Name and registered office of the insurer:",
    imprintLiabilityCompany: "Allianz Versicherungs-AG",
    imprintLiabilityCity: "10900 Berlin",
    imprintLiabilityScope: "Scope of insurance:",
    imprintLiabilityGermany: "Germany",
    imprintDisputeTitle: "EU dispute resolution",
    imprintDisputeText: "The European Commission provides a platform for online dispute resolution (ODR):",
    imprintDisputeEmail: "Our e-mail address can be found above in the site notice.",
    imprintArbitrationTitle: "Dispute resolution proceedings in front of a consumer arbitration board",
    imprintArbitrationText: "We are not willing or obliged to participate in dispute resolution proceedings in front of a consumer arbitration board.",
    imprintCreatedWith: "Created with",
  },
  de: {
    // Hero
    heroTitle: "Erwecken wir Ihre App-Idee zum Leben!",
    
    // Navigation
    navAbout: "Über mich",
    navHire: "Beauftragen",
    navReferences: "Referenzen",
    navCode: "Code",
    navBlog: "Blog",
    navApps: "Apps",
    navPrivacy: "Datenschutzerklärung",
    
    // About Section
    aboutTitle: "Über mich",
    aboutJobTitle: "Freiberuflicher App-Entwickler",
    aboutFreelanceTitle: "Freiberuflich",
    aboutFreelanceText: "Ich bin freiberuflicher Softwareentwickler mit über {years} Jahren Berufserfahrung. Mit Technologien wie C# und .NET MAUI (vormals Xamarin.Forms) entwickle ich Ihre hochwertige, plattformübergreifende Anwendung. Von der Idee bis zur Markteinführung bringe ich Ihre App im Handumdrehen in die Stores.",
    aboutCrossPlatformTitle: "Plattformübergreifend",
    aboutCrossPlatformText: "Warum plattformübergreifende Entwicklung? Durch die Verwendung einer einzigen Codebasis für mehrere Plattformen werden Kosten reduziert und die Bereitstellung von Anwendungen für Kunden auf verschiedenen Plattformen wie Android, iOS, macOS und Windows beschleunigt.",
    aboutModernTitle: "Moderne Praktiken",
    aboutModernText: "Als Verfechter moderner Softwareentwicklungsprinzipien und -praktiken wie Clean Code, Test-Driven Development und SOLID strebe ich stets danach, wartbaren und erweiterbaren Code zu liefern. In C# .NET-basierten Projekten wende ich das Model-View-ViewModel (MVVM)-Muster an, um die Geschäftslogik von der Benutzeroberfläche zu trennen und testbaren Code zu liefern.",
    aboutExperienceTitle: "Umfangreiche Erfahrung",
    aboutExperienceText: "Als erfahrener Entwickler, Open-Source-Contributor, aktives Mitglied der Stack Overflow-Community und Entwickler mehrerer Open-Source-Komponenten für Xamarin.Forms und .NET MAUI bringe ich in jedem Projekt eine Fülle von Fachwissen und Expertise ein.",
    aboutYearsExperience: "Jahre Erfahrung",
    
    // References Section
    referencesTitle: "Referenzen",
    referencesIntro: "Werden Sie einer meiner zufriedenen Kunden und lassen Sie mich Ihre moderne, plattformübergreifende App entwickeln!",
    
    // Hire Section
    hireTitle: "Beauftragen",
    hireIntro: "Lassen Sie uns gemeinsam etwas Großartiges schaffen und Ihren Kunden Mehrwert bieten.",
    hireProjectsTitle: "Projekte",
    hireProjectsText: "Sie können mich für Ihre .NET-basierten Anwendungs- und Softwareentwicklungsprojekte beauftragen. Ich biete sowohl mobile als auch Desktop-Anwendungsentwicklung an. Ob kleines, mittleres oder großes Projekt, im Team oder allein, ich helfe Ihnen bei App-Architektur, Entwicklungspraktiken, Stabilität, automatisierten Tests, Refactoring, Coaching und mehr.",
    hireIndustryTitle: "Branchenkenntnisse",
    hireIndustryText: "Mit meiner Berufserfahrung als Softwareentwickler in den Bereichen Additive Fertigung (3D-Druck), Medizinsoftware und Personal Training kann ich mich schnell an Branchenanforderungen anpassen und Ihnen und Ihrem Team helfen, das Ziel zu erreichen.",
    hireAvailabilityTitle: "Verfügbarkeit",
    hireAvailabilityText: "Mit Sitz in Deutschland bin ich für Aufträge in der gesamten Europäischen Union verfügbar. Mit fließenden Englisch- und Deutschkenntnissen sowie Grundkenntnissen in Spanisch und Portugiesisch bin ich ein flexibler und vielseitiger Entwickler für internationale Zusammenarbeit. Verfügbarkeit und Stundensatz auf Anfrage.",
    hireTouchTitle: "Kontakt aufnehmen",
    hireTouchText: "Sie möchten mit mir zusammenarbeiten? Super, kontaktieren Sie mich einfach über LinkedIn oder per E-Mail und wir besprechen Ihr Projekt.",
    
    // Code Section
    codeTitle: "Code",
    codeIntro: "Entdecken Sie einige meiner Open-Source-Repositories auf GitHub",
    linksOpenExternally: "(Links öffnen extern)",
    
    // Blog Section
    blogTitle: "Blog",
    blogIntro: "Ich schreibe über Softwareentwicklung, .NET MAUI, Xamarin.Forms und andere Themen rund um mobile und plattformübergreifende Entwicklung.",
    blogReadMore: "Mehr auf meinem Blog lesen",
    
    // Apps Section
    appsTitle: "epj apps",
    appsIntro: "Hier finden Sie einige meiner privat entwickelten Apps, die derzeit in den verschiedenen Stores erhältlich sind.",
    relistTitle: "Re:List - Free Simple Modern List Manager",
    relistTagline: "Sparen Sie Zeit und behalten Sie die Kontrolle über Ihre wichtigen Checklisten!",
    relistDescription1: "Mit Re:List können Sie Listen schnell erstellen, wiederverwenden, zurücksetzen und kopieren sowie Ihre Listenelemente effizient organisieren. Ob es sich um Ihre häufig verwendete Einkaufsliste oder eine Packliste für Ihren jährlichen Urlaub handelt, Re:List hilft Ihnen, organisiert zu bleiben. Mit Re:List werden Sie niemals mehr vergessen, Ihren Sonnenschutz oder Ihre Wintermütze einzupacken!",
    relistDescription2: "Sie können einzelne Elemente und ganze Listen kopieren, Elemente abhaken, zurücksetzen und löschen, nach Priorität, Name, Datum sortieren - Sie haben die Kontrolle über Ihre Listen. Ihre Listen sind immer bei Ihnen, sogar wenn Sie Geräte wechseln (dies ist optional und erfordert die Anmeldung mit Ihrem Google- oder Apple-Konto). Re:List ist kostenlos nutzbar und vollständig werbefrei.",
    appsPrivacyPolicy: "Datenschutz",
    
    // Footer
    footerPrivacy: "Datenschutzerklärung",
    footerImprint: "Impressum",
    
    // Impressum Section
    imprintTitle: "Impressum",
    imprintName: "Julian Ewers-Peters",
    imprintCompany: "IT-Consulting Julian Ewers-Peters",
    imprintStreet: "Brunnenstraße 4",
    imprintCity: "49214 Bad Rothenfelde",
    imprintContactTitle: "Kontakt",
    imprintPhone: "Telefon: +495424218872",
    imprintEmail: "E-Mail: julian@ewers-peters.de",
    imprintVatTitle: "Umsatzsteuer-ID",
    imprintVatText: "Umsatzsteuer-Identifikationsnummer gemäß §27a Umsatzsteuergesetz:",
    imprintVatId: "DE320743648",
    imprintLiabilityTitle: "Angaben zur Berufshaftpflichtversicherung",
    imprintLiabilityInsurer: "Name und Sitz des Versicherers:",
    imprintLiabilityCompany: "Allianz Versicherungs-AG",
    imprintLiabilityCity: "10900 Berlin",
    imprintLiabilityScope: "Geltungsbereich:",
    imprintLiabilityGermany: "Deutschland",
    imprintDisputeTitle: "EU-Streitschlichtung",
    imprintDisputeText: "Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:",
    imprintDisputeEmail: "Unsere E-Mail-Adresse finden Sie oben im Impressum.",
    imprintArbitrationTitle: "Verbraucherstreitbeilegung/Universalschlichtungsstelle",
    imprintArbitrationText: "Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.",
    imprintCreatedWith: "Erstellt mit",
  },
} as const;

export type Language = keyof typeof translations;
export type Translations = typeof translations;
